import React, { useState, useRef, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css"

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"
import Swal from "sweetalert2"
import { addPCARE, getClinic, getTodaysVisitsByClinicId2, getvision, getVisionType, getVisit, searchLensByLcode, searchFrameByFcode } from "service/api"
import Select from 'react-select';
import { jwtDecode } from "jwt-decode"
import { toast } from "react-toastify"
import Webcam from "react-webcam"


const cardTopStyle = {
    backgroundColor: "#DC4C64",
    padding: "4px",
    color: "white",
    height: "30px",
}

const defaultValue = {
    chiefcompliant: "",
    visit_no: "",
    visit_id: "",
    patientid: "",
    title: "",
    firstname: "",
    lastname: "",
    age: "",
    race: "",
    gender: "",
    hisotrauma: "",
    syscondition: "",
    medication: "",
    fmhistory: "",
    allergies: "",
    lasteexam: "",
    prenatalhis: "",
    postnatalhis: "",
    HobbiesSports: "",
    screentime: new Date().toLocaleTimeString('en-ZA', { hour: '2-digit', minute: '2-digit', timeZone: 'Africa/Johannesburg' }),
    frame_brand: "",
    frame_code: "",
    frame_id: "",
    frame_stock_id: "",
    od_spere: "",
    od_cyl: "",
    od_axis: "",
    od_add: "",
    od_seg_height: "",
    os_spere: "",
    os_cyl: "",
    os_axis: "",
    os_add: "",
    os_seg_height: "",
    pd: "",
    two_pd_number: "",
    pd_left: "",
    pd_right: "",
    lens_material: "",
    lens_tint: "",
    lens_vision: "",
    lens_subvision: "",
    lens_type: "",
    add_prism: "",
    od_vertical: "",
    od_vb_direction: "",
    od_horizontal: "",
    od_hb_direction: "",
    os_vertical: "",
    os_vb_direction: "",
    os_horizontal: "",
    os_hb_direction: "",
    pre_od_sphere: "",
    pre_od_sphere_right: '',
    pre_od_Right: "",
    pre_od_cyl: "",
    pre_od_axis: "",
    pre_od_aad: "",
    pre_od_segheight: "",
    pre_os_sphere: "",
    pre_os_cyl: "",
    pre_os_axis: "",
    pre_os_aad: "",
    pre_os_segheight: "",
    ADD: "",
    PD: "",
    material: "",
    type: "",
    extra: "",
    mobi_OD: "",
    mobi_OS: "",
    mobi_OU: "",
    mobi_NPC: "",
    mobi_Pushup: "",
    mobi_Flippers: "",
    mobi_stereopsis: "",
    cover_distance: "",
    cover_near: "",
    IOP_distance: "",
    IOP_near: "",
    color_vision: "",
    ocular_eyelisd_lashes: "",
    ocular_vitreous: "",
    ocular_conjunctiva: "",
    ocular_optic_nerve_head: "",
    ocular_cornea: "",
    ocular_anterior_chamber: "",
    ocular_pupils: "",
    ocular_macila: "",
    ocular_Lens: "",
    ocular_vessels_periphery: "",
    assesment_myopia: "",
    assesment_hyperopia: "",
    assesment_anisometropia: "",
    assesment_astigmatism: "",
    assesment_antistigmatism: "",
    assesment_pathology: "",
    Visual_OD: "",
    Visual_OS: "",
    Visual_OU: "",
    Visual_pin_OD: "",
    Visual_pin_OS: "",
    Visual_pin_OU: "",
    Visual_near_OD: "",
    Visual_near_OS: "",
    Visual_near_OU: "",
    Habitual_sphere: "",
    Habitual_cyl: "",
    Habitual_axis: "",
    Habitual_add: "",
    Habitual_left_Sphere: "",
    Habitual_left_cyl: "",
    Habitual_left_axis: "",
    Habitual_left_add: "",
    Habitual_left_seg_height: "",
    Habitual_segg_height: "",
    Prescription_right_sphere: "",
    Prescription_right_cyl: "",
    Prescription_right_axis: "",
    Prescription_right_add: "",
    Prescription_right_va: "",
    Prescription_right_prism: "",
    Prescription_right_pd: "",
    Prescription_right_seg_height: "",
    Prescription_left_sphere: "",
    Prescription_left_axis: "",
    Prescription_left_add: "",
    Prescription_left_va: "",
    Prescription_left_prism: "",
    Prescription_left_prism: "",
    Prescription_left_pd: "",
    Prescription_left_cyl: "",
    Prescription_left_seg_height: "",
    lens_subvision: "",
    lens_vision: "",
    lens_code: "",
    lens_code_id: "",
    lens_selection_material: "",
    frames_brand: "",
    frame_shape: "",
    frame_type: "",
    frame_material: "",
    frame_size: "",
    frame_color: "",
    frame_image: "",
}


document.title = "Patient Care | Form"

const Addpatientcare = () => {

    const [Patientcare, setpatientcare] = useState({ ...defaultValue });
    const [allvisit, setallvisit] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedVision, setSelectedVision] = useState(null);
    const todayDate = new Date().toISOString().split('T')[0];
    const [loader, setLoader] = useState(false);
    const [vision, setallvision] = useState({ users: [] })
    const [showFrameSelection, setshowFrameSelection] = useState(false);
    const [showLenseSelection, setLenseSelection] = useState(false);
    const [clinicIdFromToken, setClinicIdFromToken] = useState(null);
    const [allcliniclist, setallclinic] = useState([]);
    const [selectedClinic, setSelectedClinic] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpen1, setModalOpen1] = useState(false);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [modalOpen3, setModalOpen3] = useState(false);
    const [vaModal, setVaModal] = useState({ open: false, field: null });
    const [activeInput, setActiveInput] = useState(null);
    const [activeInput1, setActiveInput1] = useState(null);
    const [activeInput2, setActiveInput2] = useState(null);
    const [activeInput3, setActiveInput3] = useState(null);
    const [visionType, setallvisionType] = useState({ users: [] })
    const [filteredOptionsvisionType, setFilteredOptionsvisionType] = useState([]);
    const [selectedSubTypeRecord, setSelectedSubTypeRecord] = useState(null);
    const [selectedCoating, setSelectedCoating] = useState("");
    const [isPhotochromic, setIsPhotochromic] = useState(false);
    const [showMaterialWarning, setShowMaterialWarning] = useState(false);
    // ── Per-eye OS lens state ──
    const [selectedVisionOS, setSelectedVisionOS] = useState(null);
    const [filteredSubTypesOS, setFilteredSubTypesOS] = useState([]);
    const [selectedSubTypeRecordOS, setSelectedSubTypeRecordOS] = useState(null);
    const [selectedCoatingOS, setSelectedCoatingOS] = useState("");
    const [isPhotochromicOS, setIsPhotochromicOS] = useState(false);
    const [isOSLensEditable, setIsOSLensEditable] = useState(false);
    const osLensEditCheckboxRef = useRef(null);
    const osPhotochromicCheckboxRef = useRef(null);
    // ── Lens code search ──
    const [lensCodeQuery, setLensCodeQuery] = useState("");
    const [lensSearchResults, setLensSearchResults] = useState([]);
    const [lensSearchLoading, setLensSearchLoading] = useState(false);
    const [lensSearchOpen, setLensSearchOpen] = useState(false);
    const lensSearchRef = useRef(null);
    const [frameCodeQuery, setFrameCodeQuery] = useState("");
    const [frameSearchResults, setFrameSearchResults] = useState([]);
    const [frameSearchLoading, setFrameSearchLoading] = useState(false);
    const [frameSearchOpen, setFrameSearchOpen] = useState(false);
    const frameSearchRef = useRef(null);

    const [errors, setErrors] = useState({
        visit_no: false,
    });
    const [activeTab, setActiveTab] = useState("1");

    const [addData, setAddData] = useState({
        ...defaultValue,
        date: todayDate,
    });

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decoded = jwtDecode(token);
            setClinicIdFromToken(decoded?.clinicID || null);
        }
    }, []);

    const syncCheckboxState = (checkboxRef, value) => {
        if (checkboxRef?.current) {
            checkboxRef.current.checked = value;
        }
    };

    useEffect(() => {
        syncCheckboxState(osLensEditCheckboxRef, isOSLensEditable);
    }, [isOSLensEditable]);

    useEffect(() => {
        syncCheckboxState(osPhotochromicCheckboxRef, isPhotochromicOS);
    }, [isPhotochromicOS]);

    const handleClinicChange = async (e) => {
        const clinicId = e.target.value;
        setSelectedClinic(clinicId);
        setallvisit([]); // reset previous visits

        if (clinicId) {
            fetchTodaysVisitsByClinic(clinicId);
        }
    };

    const getallclinic = async () => {
        try {
            let response;
            response = await getClinic();
            setallclinic(response.data);
        } catch (err) {
            console.error("Error fetching clinic(s)", err);
        }
    };

    useEffect(() => {
        if (!clinicIdFromToken) {
            getallclinic();
        }
    }, [clinicIdFromToken]);


    const onValueChange = e => {
        const { name, value } = e.target;
        setpatientcare({ ...Patientcare, [name]: value });

        setAddData((prevData) => {
            const updatedData = { ...prevData, [name]: value };
            return updatedData;
        });

        if (name === "freame_selection") {
            setshowFrameSelection(value === "yes");
        }
        if (name === "lense_selection") {
            setLenseSelection(value === "yes");
        }
    };

    const navigate = useNavigate()

    const fetchTodaysVisitsByClinic = async (clinicId) => {
        try {
            setLoading(true);
            const response = await getTodaysVisitsByClinicId2(clinicId);
            setallvisit(response?.data || []);
        } catch (err) {
            console.error("Error fetching today's visits:", err);
            setallvisit([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (clinicIdFromToken) {
            fetchTodaysVisitsByClinic(clinicIdFromToken);
        }
    }, [clinicIdFromToken]);


    const addpatientcareDetails = async (e) => {
        e.preventDefault();

        // Validation checks
        let validationErrors = {};
        validationErrors.visit_no = Patientcare.visit_no === "";

        setErrors(validationErrors);

        const hasErrors = Object.values(validationErrors).some((error) => error === true);

        if (hasErrors) {
            toast.error("Please fill out all required fields before saving.");
            return;
        }

        setLoader(true);
        try {
            const payload = { ...Patientcare, ...addData };
            // Remove empty ObjectId fields — backend will reject empty string for ObjectId type
            const objectIdFields = ["visit_id", "patientid", "lens_code_id", "lens_stock_id", "frame_id", "frame_stock_id"];
            objectIdFields.forEach(field => {
                if (!payload[field]) delete payload[field];
            });
            await addPCARE(payload);
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Patientcare Updated Successfully!'
            }).then(() => {
                navigate('/ViewPatientcare');
            });
        } catch (error) {
            console.error('Error Updating Patientcare:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to Update Patientcare.',
            });
        } finally {
            setLoader(false); // Hide loader
        }

    };

    useEffect(() => {
        // getallvisit();
        getALLTodaysVisitsByClinicId();
        getVision();
        getVisiontype();
    }, []);

    // const getallvisit = async () => {
    //     let response = await getVisit();
    //     setallvisit(response.data);
    // }
    const getALLTodaysVisitsByClinicId = async () => {
        try {
            const token = localStorage.getItem("token");
            let response;
            if (token) {
                const decoded = jwtDecode(token);
                const clinicID = decoded?.clinicID;

                if (clinicID) {
                    response = await getTodaysVisitsByClinicId2(clinicID);
                } else {
                    response = await getVisit();
                }

                if (response?.data) {
                    setallvisit(response.data);
                } else {
                    setallvisit(response.data);
                }
            }
        } catch (error) {
            console.log("Error while fetching data:", error);
            setallvisit(response.data);
        } finally {
            setLoading(false);
        }
    };

    const handlevisitChange = (selectedOption) => {
        const selectedConsignee = allvisit.find(patient => patient.visit_no === selectedOption.value);
        if (selectedConsignee) {
            setpatientcare({
                ...Patientcare,
                visit_no: selectedConsignee.visit_no,
                visit_id: selectedConsignee._id,
                patientid: selectedConsignee._id,
                title: selectedConsignee.title,
                firstname: selectedConsignee.firstname,
                lastname: selectedConsignee.lastname,
                age: selectedConsignee.age,
                race: selectedConsignee.patientid?.race || "",
                gender: selectedConsignee.patientid?.gender
            });
            // ✅ Also update addData so it doesn't overwrite visit_id on submit
            setAddData(prev => ({
                ...prev,
                visit_id: selectedConsignee._id,
                visit_no: selectedConsignee.visit_no,
            }));
        }
    };

    // close lens search dropdown on outside click
    useEffect(() => {
        const handler = (e) => {
            if (lensSearchRef.current && !lensSearchRef.current.contains(e.target)) {
                setLensSearchOpen(false);
            }
            if (frameSearchRef.current && !frameSearchRef.current.contains(e.target)) {
                setFrameSearchOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // ── Lens code search handlers ─────────────────────────────────
    const handleLensCodeSearch = async (query) => {
        setLensCodeQuery(query);
        if (!query.trim()) { setLensSearchResults([]); setLensSearchOpen(false); return; }
        const clinicId = clinicIdFromToken || selectedClinic || "";
        setLensSearchLoading(true);
        try {
            const res = await searchLensByLcode(query.trim(), clinicId);
            setLensSearchResults(res.data || []);
            setLensSearchOpen(true);
        } catch (err) {
            console.error("Lens search error:", err);
            setLensSearchResults([]);
            setLensSearchOpen(true); // keep open to show "no results"
        } finally {
            setLensSearchLoading(false);
        }
    };

    const COATING_KEY_MAP = {
        UC: "uc", HC: "hc", "HMC Blue": "hmc_blue", "SHMC Blue": "shmc_blue",
    };
    const COATING_LABEL_MAP = {
        uc: "UC – Uncoated", hc: "HC – Hard Coat",
        hmc_blue: "HMC Blue – Multi-Coat Blue", shmc_blue: "SHMC Blue – Super Multi-Coat Blue",
    };

    const handleLensCodeSelect = (stockItem) => {
        const lensDoc = stockItem.lname_id; // populated lens document
        if (!lensDoc) return;

        const visionId = lensDoc.lens_vision?._id || lensDoc.lens_vision || "";
        const subType  = lensDoc.sub_type || lensDoc.lens_subvision_name || "";
        const coatKey  = COATING_KEY_MAP[lensDoc.lens_type] || lensDoc.lens_type || "";
        const material = lensDoc.lens_material || "";
        const isPhotoLens = !!lensDoc.photochromic;

        // find vision record
        const matchedVision = vision.users.find(u => String(u._id) === String(visionId));

        // find sub-type record from visionType
        const filteredTypes = visionType.users.filter(vt =>
            String(vt.vision?._id || vt.vision) === String(visionId)
        );
        const matchedSubType = filteredTypes.find(vt => vt.sub_type === subType) || null;

        // ── Set OD ──
        setSelectedVision(visionId);
        setFilteredOptionsvisionType(filteredTypes);
        setSelectedSubTypeRecord(matchedSubType);
        setSelectedCoating(coatKey);
        setIsPhotochromic(isPhotoLens);

        // ── Mirror to OS (same lens, OS unlocked automatically) ──
        setSelectedVisionOS(visionId);
        setFilteredSubTypesOS(filteredTypes);
        setSelectedSubTypeRecordOS(matchedSubType);
        setSelectedCoatingOS(coatKey);
        setIsPhotochromicOS(isPhotoLens);

        // ── Normalize material to match pill labels (case-insensitive) ──
        const PILL_MATERIALS = ["CR-39(Plastic)", "Polycarbonate", "Glass", "Uncut"];
        const normalizedMaterial = PILL_MATERIALS.find(
            p => p.toLowerCase() === material.toLowerCase()
        ) || material;

        const lensCode   = stockItem.lcode || lensDoc.lens_code || "";
        const lensCodeId = stockItem._id || "";           // stock item ObjectId
        const lensDocId  = lensDoc._id || "";             // lens document ObjectId

        // ── Update addData / Patientcare for both eyes ──
        const patch = {
            lens_vision_od: visionId,
            lens_vision_os: visionId,
            lens_vision: visionId,
            lens_vision_name: matchedVision?.vision || lensDoc.lens_vision_name || "",
            lens_subvision: matchedSubType?._id || "",
            lens_subvision_name: subType,
            sub_type_od: subType,
            sub_type_os: subType,
            lens_type_od: coatKey,
            lens_type_os: coatKey,
            lens_type: coatKey,
            extra: isPhotoLens ? "yes" : "no",
            extra_od: isPhotoLens ? "yes" : "no",
            extra_os: isPhotoLens ? "yes" : "no",
            material: normalizedMaterial,
            lens_code: lensCode,
            lens_code_id: lensDocId,
            lens_stock_id: lensCodeId,
        };
        setAddData(prev => ({ ...prev, ...patch }));
        setpatientcare(prev => ({ ...prev, ...patch }));

        // ── Close dropdown ──
        setLensCodeQuery(lensCode);
        setLensSearchResults([]);
        setLensSearchOpen(false);
    };

    const handleFrameCodeSearch = async (query) => {
        setFrameCodeQuery(query);
        const clinicId = clinicIdFromToken || selectedClinic || "";

        if (!clinicId) {
            setFrameSearchResults([]);
            setFrameSearchOpen(false);
            setFrameSearchLoading(false);
            if (query.trim()) {
                toast.info("Please select Practice first before searching frame code.", {
                    position: "top-center",
                    autoClose: 1500,
                });
            }
            return;
        }

        if (!query.trim()) {
            setFrameSearchResults([]);
            setFrameSearchOpen(false);
            return;
        }

        setFrameSearchLoading(true);
        try {
            const res = await searchFrameByFcode(query.trim(), clinicId);
            setFrameSearchResults(res.data || []);
            setFrameSearchOpen(true);
        } catch (error) {
            console.error("Frame search error:", error);
            setFrameSearchResults([]);
            setFrameSearchOpen(true);
        } finally {
            setFrameSearchLoading(false);
        }
    };

    const handleFrameCodeSelect = (stockItem) => {
        const frameItem = stockItem.fname_id;
        if (!frameItem) return;

        const patch = {
            frame_brand: frameItem.frame_name || "",
            frame_code: stockItem.fcode || "",
            frame_id: frameItem._id || "",
            frame_stock_id: stockItem._id || "",
            frames_brand: frameItem.frame_name || "",
            frame_color: frameItem.frame_color || "",
            frame_size: frameItem.frame_size || "",
            frame_material: frameItem.frame_material || "",
            frame_type: frameItem.frame_type || "",
            frame_shape: frameItem.frame_shape || "",
        };

        setAddData((prev) => ({ ...prev, ...patch }));
        setpatientcare((prev) => ({ ...prev, ...patch }));
        setFrameCodeQuery(stockItem.fcode || "");
        setFrameSearchResults([]);
        setFrameSearchOpen(false);
    };
    // ─────────────────────────────────────────────────────────────

    const handleVisionChange = (e) => {
        const selectedVisionId = e.target.value;
        setSelectedVision(selectedVisionId);
        const matchedVision = vision.users.find((user) => user._id === selectedVisionId);
        const filteredTypes = visionType.users.filter((vt) => vt.vision?._id === selectedVisionId || vt.vision === selectedVisionId);
        setAddData(prev => ({
            ...prev,
            lens_vision: selectedVisionId,
            lens_vision_od: selectedVisionId,
            lens_vision_name: matchedVision ? matchedVision.vision : "",
        }));
        setpatientcare(prev => ({ ...prev, lens_vision: selectedVisionId, lens_vision_od: selectedVisionId }));
        setFilteredOptionsvisionType(filteredTypes);
        setSelectedSubTypeRecord(null);
        setSelectedCoating("");
        setIsPhotochromic(false);

        if (!isOSLensEditable) {
            setSelectedVisionOS(selectedVisionId);
            setFilteredSubTypesOS(filteredTypes);
            setSelectedSubTypeRecordOS(null);
            setSelectedCoatingOS("");
            setIsPhotochromicOS(false);
            setAddData(prev => ({
                ...prev,
                lens_vision_os: selectedVisionId,
                lens_subvision_os: "",
                lens_type_os: "",
                extra_os: "no",
            }));
            setpatientcare(prev => ({
                ...prev,
                lens_vision_os: selectedVisionId,
                lens_subvision_os: "",
                lens_type_os: "",
                extra_os: "no",
            }));
        }
    };

    const handleSubTypeChange = (e) => {
        const subTypeVal = e.target.value;
        const record = filteredOptionsvisionType.find(vt => vt.sub_type === subTypeVal);
        setSelectedSubTypeRecord(record || null);
        setSelectedCoating("");
        setIsPhotochromic(false);
        setpatientcare(prev => ({ ...prev, lens_subvision: record?._id || "", lens_subvision_od: record?._id || "" }));
        setAddData(prev => ({ ...prev, lens_subvision: record?._id || "", lens_subvision_od: record?._id || "" }));

        if (!isOSLensEditable) {
            setSelectedSubTypeRecordOS(record || null);
            setSelectedCoatingOS("");
            setIsPhotochromicOS(false);
            setAddData(prev => ({
                ...prev,
                lens_subvision_os: record?._id || "",
                lens_type_os: "",
                extra_os: "no",
            }));
            setpatientcare(prev => ({
                ...prev,
                lens_subvision_os: record?._id || "",
                lens_type_os: "",
                extra_os: "no",
            }));
        }
    };

    const handleCoatingChange = (e) => {
        const coating = e.target.value;
        setSelectedCoating(coating);
        setpatientcare(prev => ({ ...prev, type: coating, lens_type_od: coating }));
        setAddData(prev => ({ ...prev, type: coating, lens_type_od: coating }));

        if (!isOSLensEditable) {
            setSelectedCoatingOS(coating);
            setAddData(prev => ({ ...prev, lens_type_os: coating }));
            setpatientcare(prev => ({ ...prev, lens_type_os: coating }));
        }
    };

    const handlePhotochromicChange = () => {
        const newVal = !isPhotochromic;
        setIsPhotochromic(newVal);
        setpatientcare(prev => ({ ...prev, extra: newVal ? "yes" : "no", extra_od: newVal ? "yes" : "no" }));
        setAddData(prev => ({ ...prev, extra: newVal ? "yes" : "no", extra_od: newVal ? "yes" : "no" }));

        if (!isOSLensEditable) {
            setIsPhotochromicOS(newVal);
            setAddData(prev => ({ ...prev, extra_os: newVal ? "yes" : "no" }));
            setpatientcare(prev => ({ ...prev, extra_os: newVal ? "yes" : "no" }));
        }
    };

    const handleOSLensEditToggle = () => {
        const nextEditable = !isOSLensEditable;
        setIsOSLensEditable(nextEditable);

        if (!nextEditable) {
            setSelectedVisionOS(selectedVision);
            setFilteredSubTypesOS(filteredOptionsvisionType);
            setSelectedSubTypeRecordOS(selectedSubTypeRecord);
            setSelectedCoatingOS(selectedCoating);
            setIsPhotochromicOS(isPhotochromic);
            setAddData(prev => ({
                ...prev,
                lens_vision_os: selectedVision || "",
                lens_subvision_os: selectedSubTypeRecord?._id || "",
                lens_type_os: selectedCoating || "",
                extra_os: isPhotochromic ? "yes" : "no",
            }));
            setpatientcare(prev => ({
                ...prev,
                lens_vision_os: selectedVision || "",
                lens_subvision_os: selectedSubTypeRecord?._id || "",
                lens_type_os: selectedCoating || "",
                extra_os: isPhotochromic ? "yes" : "no",
            }));
        }
    };

    const handleVisionChangeOS = (e) => {
        const vId = e.target.value;
        setSelectedVisionOS(vId);
        const filteredTypes = visionType.users.filter((vt) => vt.vision?._id === vId || vt.vision === vId);
        setFilteredSubTypesOS(filteredTypes);
        setSelectedSubTypeRecordOS(null);
        setSelectedCoatingOS("");
        setIsPhotochromicOS(false);
        setAddData(prev => ({ ...prev, lens_vision_os: vId }));
        setpatientcare(prev => ({ ...prev, lens_vision_os: vId }));
    };

    const handleSubTypeChangeOS = (e) => {
        const subTypeVal = e.target.value;
        const record = filteredSubTypesOS.find(vt => vt.sub_type === subTypeVal);
        setSelectedSubTypeRecordOS(record || null);
        setSelectedCoatingOS("");
        setIsPhotochromicOS(false);
        setAddData(prev => ({ ...prev, lens_subvision_os: record?._id || "" }));
        setpatientcare(prev => ({ ...prev, lens_subvision_os: record?._id || "" }));
    };

    const handleCoatingChangeOS = (e) => {
        const coating = e.target.value;
        setSelectedCoatingOS(coating);
        setAddData(prev => ({ ...prev, lens_type_os: coating }));
        setpatientcare(prev => ({ ...prev, lens_type_os: coating }));
    };

    const handlePhotochromicChangeOS = () => {
        const newVal = !isPhotochromicOS;
        setIsPhotochromicOS(newVal);
        setAddData(prev => ({ ...prev, extra_os: newVal ? "yes" : "no" }));
        setpatientcare(prev => ({ ...prev, extra_os: newVal ? "yes" : "no" }));
    };

    const getVision = async () => {
        try {
            let response = await getvision()
            if (response.error) {
                console.log("Error while fetching data:", response.error)
            } else {
                setallvision({ users: response.data || [] })
            }
        } catch (error) {
            console.log("Error while fetching data:", error)
        }
    }

    const getVisiontype = async () => {
        try {
            const response = await getVisionType();
            if (response.error) {
                console.log("Error while fetching data:", response.error);
            } else {
                setallvisionType({ users: response.data || [] });
                console.log("Vision type data fetched:", response.data);
            }
        } catch (error) {
            console.log("Error while fetching vision type data:", error);
        }
    };

    const [frameCaptureModal, setFrameCaptureModal] = useState(false);
    const [webcamImage, setWebcamImage] = useState(null);
    const webcamRef = useRef(null);
    const captureImage = () => {
        const imageSrc = webcamRef.current.getScreenshot();

        // Store in webcamImage state (for preview)
        setWebcamImage(imageSrc);

        // Store in main patientcare data
        setpatientcare(prev => ({ ...prev, frame_image: imageSrc }));

        // Close the modal
        setFrameCaptureModal(false);
    };

    const handleInputClick = inputName => {
        setActiveInput(inputName);
        setModalOpen(true);
    };
    const handleInputClick1 = inputName => {
        setActiveInput1(inputName);
        setModalOpen1(true);
    };
    const handleInputClick2 = inputName => {
        setActiveInput2(inputName);
        setModalOpen2(true);
    };
    const handleInputClick3 = inputName => {
        setActiveInput3(inputName);
        setModalOpen3(true);
    };

    const VA_VALUES = ["LP", "6/60", "6/48", "6/30", "6/24", "6/15", "6/120", "6/9", "6/7.5", "6/6", "6/4.5"];

    const handleVAFieldClick = (fieldName) => {
        setVaModal({ open: true, field: fieldName });
    };

    const handleVASelect = (value) => {
        setAddData(prev => ({ ...prev, [vaModal.field]: value }));
        setVaModal({ open: false, field: null });
    };


    const handleSelectValue = value => {
        setAddData(prev => ({ ...prev, [activeInput]: value }));
        setpatientcare(prev => ({ ...prev, [activeInput]: value }));
        setModalOpen(false);
    };
    const handleSelectValue1 = value => {
        setAddData(prev => ({ ...prev, [activeInput1]: value }));
        setpatientcare(prev => ({ ...prev, [activeInput1]: value }));
        setModalOpen1(false);
    };
    const handleSelectValue2 = value => {
        setAddData(prev => ({ ...prev, [activeInput2]: value }));
        setpatientcare(prev => ({ ...prev, [activeInput2]: value }));
        setModalOpen2(false);
    };
    const handleSelectValue3 = value => {
        setAddData(prev => ({ ...prev, [activeInput3]: value }));
        setpatientcare(prev => ({ ...prev, [activeInput3]: value }));
        setModalOpen3(false);

    };

    const renderDropdownOptions = () => {
        const options = [];
        for (let i = 1; i <= 180; i++) {
            options.push(
                <option key={i} value={i}>
                    {i}
                </option>
            );
        }
        return options;
    };
    const renderDropdownOptions1 = () => {
        const options = [];
        for (let i = 1; i <= 50; i++) {
            options.push(
                <option key={i} value={i}>
                    {i}
                </option>
            );
        }
        return options;
    };

    const tabs = [
        { id: "1", label: "Patient & History", icon: "mdi-account-outline" },
        { id: "2", label: "Visual Acuity", icon: "mdi-eye-outline" },
        { id: "3", label: "Binocular Vision", icon: "mdi-eye-check-outline" },
        { id: "4", label: "Ocular Health", icon: "mdi-medical-bag" },
        { id: "5", label: "Prescription", icon: "mdi-prescription" },
        { id: "6", label: "Optical & Frame", icon: "mdi-glasses" },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="page-title">Patient Care</h4>
                        <Link to="/ViewPatientcare" className="btn btn-danger">
                            <i className="mdi mdi-format-list-bulleted me-1" />List
                        </Link>
                    </div>

                    <Card>
                        <CardBody style={{ padding: 0 }}>

                            {/* ── Tab Navigation ── */}
                            <div style={{ borderBottom: "2px solid #f0e8e8", background: "#fdf8f8", borderRadius: "8px 8px 0 0", padding: "0 16px" }}>
                                <Nav tabs style={{ border: "none", gap: 4 }}>
                                    {tabs.map(tab => (
                                        <NavItem key={tab.id}>
                                            <NavLink
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "12px 16px",
                                                    fontWeight: 600,
                                                    fontSize: 13,
                                                    border: "none",
                                                    borderBottom: activeTab === tab.id ? `3px solid ${cardTopStyle.backgroundColor}` : "3px solid transparent",
                                                    color: activeTab === tab.id ? cardTopStyle.backgroundColor : "#888",
                                                    background: "transparent",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 6,
                                                    whiteSpace: "nowrap",
                                                }}
                                                onClick={() => setActiveTab(tab.id)}
                                            >
                                                <i className={`mdi ${tab.icon}`} style={{ fontSize: 15 }} />
                                                {tab.label}
                                            </NavLink>
                                        </NavItem>
                                    ))}
                                </Nav>
                            </div>

                            {/* ── Tab Content ── */}
                            <TabContent activeTab={activeTab} style={{ padding: "20px 24px" }}>

                                {/* ── Tab 1: Patient & History ── */}
                                <TabPane tabId="1">
                                    <Form>
                                        <div style={cardTopStyle}><CardTitle className="mb-4">Patient Details</CardTitle></div>
                                        <br />
                                        <Row>
                                            {!clinicIdFromToken && (
                                                <Col md={3}>
                                                    <div className="mb-3">
                                                        <Label>Practice</Label>
                                                        <select className="form-control" value={selectedClinic} onChange={handleClinicChange}>
                                                            <option value="">Select Practice</option>
                                                            {allcliniclist.map((clinic) => (
                                                                <option key={clinic._id} value={clinic._id}>{clinic.name}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </Col>
                                            )}
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Visit No.</Label>
                                                    <Select
                                                        options={allvisit.map(patient => ({ value: patient.visit_no, label: patient.visit_no }))}
                                                        onChange={handlevisitChange}
                                                        className="form-control"
                                                        name="visit_no"
                                                    />
                                                    {errors.visit_no && <span className="text-danger">*This field required</span>}
                                                </div>
                                            </Col>
                                            <Input type="text" className="form-control" hidden readOnly name="visit_id" value={Patientcare.visit_id} onChange={(e) => onValueChange(e)} />
                                            <Col md={1}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Title:</Label>
                                                    <Input type="text" className="form-control" name="title" readOnly value={Patientcare.title} onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">First Name:</Label>
                                                    <Input type="text" className="form-control" name="firstname" readOnly value={Patientcare.firstname} onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Last Name:</Label>
                                                    <Input type="text" className="form-control" name="lastname" readOnly value={Patientcare.lastname} onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Race:</Label>
                                                    <Input type="text" className="form-control" name="race" readOnly value={Patientcare.race} onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                            <Col md={2}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Gender:</Label>
                                                    <Input type="text" className="form-control" readOnly name="gender" value={Patientcare.gender} onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                            <Col md={1}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Age:</Label>
                                                    <Input type="text" className="form-control" name="age" value={Patientcare.age} onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <div style={cardTopStyle}><CardTitle className="mb-4">Case History</CardTitle></div>
                                        <br />
                                        <Row>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Chief Complaint :</Label>
                                                    <select className="form-control" name="chiefcompliant" onChange={(e) => onValueChange(e)}>
                                                        <option value="">Select</option>
                                                        <option>Blurry Vision</option>
                                                        <option>Diplopia</option>
                                                        <option>Distance Vision</option>
                                                        <option>Foreign body sensation</option>
                                                        <option>Near Vision</option>
                                                        <option>Photophobia</option>
                                                        <option>Screen</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">History Of Trauma :</Label>
                                                    <Input type="text" className="form-control" name="hisotrauma" placeholder="History Of Trauma"
                                                        style={{ textTransform: 'uppercase' }} onChange={(e) => {
                                                            const upperValue = e.target.value.toUpperCase();
                                                            onValueChange({
                                                                target: {
                                                                    name: e.target.name,
                                                                    value: upperValue
                                                                }
                                                            });
                                                        }} />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Systematic Conditions :</Label>
                                                    <select className="form-control" name="syscondition" onChange={(e) => onValueChange(e)}>
                                                        <option value="">Select</option>
                                                        <option>Diabetic</option>
                                                        <option>Hypertension</option>
                                                        <option>Other</option>
                                                        <option>Unknown</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Medication :</Label>
                                                    <select className="form-control" name="medication" onChange={(e) => onValueChange(e)}>
                                                        <option value="">Select</option>
                                                        <option>Yes</option>
                                                        <option>No</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Family History :</Label>
                                                    <select className="form-control" name="fmhistory" onChange={(e) => onValueChange(e)}>
                                                        <option value="">Select</option>
                                                        <option>Yes</option>
                                                        <option>No</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Allergies :</Label>
                                                    <select className="form-control" name="allergies" onChange={(e) => onValueChange(e)}>
                                                        <option value="">Select</option>
                                                        <option>Dust</option>
                                                        <option>Food</option>
                                                        <option>Pollen</option>
                                                        <option>Other</option>
                                                        <option>None</option>
                                                    </select>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Last Eye Exam :</Label>
                                                    <Input type="date" className="form-control" name="lasteexam" placeholder="Last Eye Exam" onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Occupation :</Label>
                                                    <Input type="text" className="form-control" name="postnatalhis" placeholder="Occupation" style={{ textTransform: 'uppercase' }} onChange={(e) => {
                                                        const upperValue = e.target.value.toUpperCase();
                                                        onValueChange({
                                                            target: {
                                                                name: e.target.name,
                                                                value: upperValue
                                                            }
                                                        });
                                                    }} />
                                                </div>
                                            </Col>
                                            {/* <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Pre-natal History :</Label>
                                                    <Input type="text" className="form-control" name="prenatalhis" placeholder="Pre-natal History" onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col> */}
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Hobbies/Sports :</Label>
                                                    <Input type="text" className="form-control" name="HobbiesSports" placeholder="Hobbies/Sports" style={{ textTransform: 'uppercase' }} onChange={(e) => {
                                                        const upperValue = e.target.value.toUpperCase();
                                                        onValueChange({
                                                            target: {
                                                                name: e.target.name,
                                                                value: upperValue
                                                            }
                                                        });
                                                    }} />
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-country-Input">Screen Time :</Label>
                                                    <Input type="text" className="form-control" name="screentime" placeholder="Screen Time" value={Patientcare.screentime} onChange={(e) => onValueChange(e)} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="d-flex justify-content-end mt-2">
                                            <Button color="danger" onClick={() => setActiveTab("2")}>Next <i className="mdi mdi-arrow-right ms-1" /></Button>
                                        </div>
                                    </Form>
                                </TabPane>

                                {/* ── Tab 2: Visual Acuity ── */}
                                <TabPane tabId="2">
                                    <Row>
                                        <Col md={5}>
                                            <div style={cardTopStyle}><CardTitle className="mb-4">Visual Acuity</CardTitle></div>
                                            <br />
                                            <div className="table-responsive">
                                                <Table className="table mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th></th>
                                                            <th>OD</th>
                                                            <th>OS</th>
                                                            <th>OU</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">Distance Unaided</th>
                                                            <td><Input type="text" className="form-control" name="Visual_OD" value={addData.Visual_OD || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_OD")} onChange={e => onValueChange(e)} /></td>
                                                            <td><Input type="text" className="form-control" name="Visual_OS" value={addData.Visual_OS || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_OS")} onChange={e => onValueChange(e)} /></td>
                                                            <td><Input type="text" className="form-control" name="Visual_OU" value={addData.Visual_OU || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_OU")} onChange={e => onValueChange(e)} /></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Distance pin Hole</th>
                                                            <td><Input type="text" className="form-control" name="Visual_pin_OD" value={addData.Visual_pin_OD || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_pin_OD")} onChange={e => onValueChange(e)} /></td>
                                                            <td><Input type="text" className="form-control" name="Visual_pin_OS" value={addData.Visual_pin_OS || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_pin_OS")} onChange={e => onValueChange(e)} /></td>
                                                            <td><Input type="text" className="form-control" name="Visual_pin_OU" value={addData.Visual_pin_OU || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_pin_OU")} onChange={e => onValueChange(e)} /></td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Near Visual Acuity</th>
                                                            <td><Input type="text" className="form-control" name="Visual_near_OD" value={addData.Visual_near_OD || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_near_OD")} onChange={e => onValueChange(e)} /></td>
                                                            <td><Input type="text" className="form-control" name="Visual_near_OS" value={addData.Visual_near_OS || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_near_OS")} onChange={e => onValueChange(e)} /></td>
                                                            <td><Input type="text" className="form-control" name="Visual_near_OU" value={addData.Visual_near_OU || ""} readOnly style={{ cursor: "pointer", background: "#fff" }} onClick={() => handleVAFieldClick("Visual_near_OU")} onChange={e => onValueChange(e)} /></td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col>
                                        <Col md={7}>
                                            <div style={cardTopStyle}><CardTitle className="mb-4">Habitual Prescription</CardTitle></div>
                                            <br />
                                            <div className="table-responsive">
                                                <Table className="table mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th></th>
                                                            <th>Sphere</th>
                                                            <th style={{ width: 70 }}>Cyl</th>
                                                            <th>Axis</th>
                                                            <th>Add</th>
                                                            <th>Seg Height</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row">OD[Right]</th>
                                                            <td style={{ width: 150 }}><Input type="text" className="form-control" name="Habitual_sphere" value={addData.Habitual_sphere} onClick={() => handleInputClick("Habitual_sphere")} onChange={e => onValueChange(e)} /></td>

                                                            <td style={{ width: 150 }}><Input type="text" className="form-control" name="Habitual_cyl" value={addData.Habitual_cyl} onClick={() => handleInputClick1("Habitual_cyl")} onChange={e => onValueChange(e)} /></td>
                                                            <td>
                                                                <select name="Habitual_axis" className="form-control" onChange={e => onValueChange(e)}>
                                                                    <option defaultValue>Select</option>
                                                                    {renderDropdownOptions()}
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <select name="Habitual_add" className="form-control" onChange={e => onValueChange(e)}>
                                                                    <option defaultValue>Select</option>
                                                                    <option>+0.75</option><option>+1.00</option><option>+1.25</option><option>+1.50</option>
                                                                    <option>+1.75</option><option>+2.00</option><option>+2.25</option><option>+2.50</option>
                                                                    <option>+2.75</option><option>+3.00</option><option>+3.25</option><option>+3.50</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <select name="Habitual_segg_height" className="form-control" onChange={e => onValueChange(e)}>
                                                                    <option defaultValue>Select</option>
                                                                    {renderDropdownOptions1()}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">OS[Left]</th>
                                                            <td style={{ width: 150 }}><Input type="text" className="form-control" name="Habitual_left_Sphere" value={addData.Habitual_left_Sphere} onClick={() => handleInputClick("Habitual_left_Sphere")} onChange={e => onValueChange(e)} /></td>
                                                            <td style={{ width: 150 }}><Input type="text" className="form-control" name="Habitual_left_cyl" value={addData.Habitual_left_cyl} onClick={() => handleInputClick1("Habitual_left_cyl")} onChange={e => onValueChange(e)} /></td>
                                                            <td>
                                                                <select name="Habitual_left_axis" className="form-control" onChange={e => onValueChange(e)}>
                                                                    <option defaultValue>Select</option>
                                                                    {renderDropdownOptions()}
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <select name="Habitual_left_add" className="form-control" onChange={e => onValueChange(e)}>
                                                                    <option defaultValue>Select</option>
                                                                    <option>+0.75</option><option>+1.00</option><option>+1.25</option><option>+1.50</option>
                                                                    <option>+1.75</option><option>+2.00</option><option>+2.25</option><option>+2.50</option>
                                                                    <option>+2.75</option><option>+3.00</option><option>+3.25</option><option>+3.50</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <select name="Habitual_left_seg_height" className="form-control" onChange={e => onValueChange(e)}>
                                                                    <option defaultValue>Select</option>
                                                                    {renderDropdownOptions1()}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="d-flex justify-content-between mt-3">
                                        <Button color="secondary" outline onClick={() => setActiveTab("1")}><i className="mdi mdi-arrow-left me-1" /> Back</Button>
                                        <Button color="danger" onClick={() => setActiveTab("3")}>Next <i className="mdi mdi-arrow-right ms-1" /></Button>
                                    </div>
                                </TabPane>



                                {/* ── Tab 3: Binocular Vision ── */}
                                <TabPane tabId="3">
                                    <Row>
                                        <Col md={4}>
                                            <div style={cardTopStyle}><CardTitle className="mb-4">Mobilities</CardTitle></div>
                                            <br />
                                            <Row>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">OD :</Label><Input type="text" className="form-control" name="mobi_OD" placeholder="OD" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">OS :</Label><Input type="text" className="form-control" name="mobi_OS" placeholder="OS" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">OU :</Label><Input type="text" className="form-control" name="mobi_OU" placeholder="OU" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">NPC :</Label><Input type="text" className="form-control" name="mobi_NPC" placeholder="NPC" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">Push Up :</Label><Input type="text" className="form-control" name="mobi_Pushup" placeholder="pushup" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">Flippers :</Label><Input type="text" className="form-control" name="mobi_Flippers" placeholder="flippers" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">Stereopsis :</Label><Input type="text" className="form-control" name="mobi_stereopsis" placeholder="stereopsis" onChange={(e) => onValueChange(e)} /></div></Col>
                                            </Row>
                                        </Col>
                                        <Col md={4}>
                                            <div style={cardTopStyle}><CardTitle className="mb-4">Cover Test</CardTitle></div>
                                            <br />
                                            <Row>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">Distance :</Label><Input type="text" className="form-control" name="cover_distance" placeholder="distance" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">Near :</Label><Input type="text" className="form-control" name="cover_near" placeholder="near" onChange={(e) => onValueChange(e)} /></div></Col>
                                            </Row>
                                            <div style={cardTopStyle} className="mt-3"><CardTitle className="mb-4">IOP</CardTitle></div>
                                            <br />
                                            <Row>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">Distance :</Label><Input type="text" className="form-control" name="IOP_distance" placeholder="distance" onChange={(e) => onValueChange(e)} /></div></Col>
                                                <Col md={6}><div className="mb-3"><Label htmlFor="formrow-country-Input">Near :</Label><Input type="text" className="form-control" name="IOP_near" placeholder="near" onChange={(e) => onValueChange(e)} /></div></Col>
                                            </Row>
                                        </Col>
                                        <Col md={4}>
                                            <div style={cardTopStyle}><CardTitle className="mb-4">Colour Vision</CardTitle></div>
                                            <br />
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Colour Vision :</Label>
                                                <Input type="text" className="form-control" name="color_vision" placeholder="near" onChange={(e) => onValueChange(e)} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="d-flex justify-content-between mt-3">
                                        <Button color="secondary" outline onClick={() => setActiveTab("2")}><i className="mdi mdi-arrow-left me-1" /> Back</Button>
                                        <Button color="danger" onClick={() => setActiveTab("4")}>Next <i className="mdi mdi-arrow-right ms-1" /></Button>
                                    </div>
                                </TabPane>

                                {/* ── Tab 4: Ocular Health ── */}
                                <TabPane tabId="4">
                                    <div style={cardTopStyle}><CardTitle className="mb-4">Ocular Health</CardTitle></div>
                                    <br />
                                    <Row>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Eyelids and Lashes :</Label><Input type="text" className="form-control" name="ocular_eyelisd_lashes" placeholder="Eyelids and Lashes" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Vitreous :</Label><Input type="text" className="form-control" name="ocular_vitreous" placeholder="Vitreous" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Conjunctiva :</Label><Input type="text" className="form-control" name="ocular_conjunctiva" placeholder="Conjunctiva" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Optic Nerve Head :</Label><Input type="text" className="form-control" name="ocular_optic_nerve_head" placeholder="Optic Nerve Head" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Cornea :</Label><Input type="text" className="form-control" name="ocular_cornea" placeholder="Cornea" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Anterior Chamber :</Label><Input type="text" className="form-control" name="ocular_anterior_chamber" placeholder="Anterior Chamber" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Pupils :</Label><Input type="text" className="form-control" name="ocular_pupils" placeholder="Pupils" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Macula :</Label><Input type="text" className="form-control" name="ocular_macila" placeholder="Macula" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Lens :</Label><Input type="text" className="form-control" name="ocular_Lens" placeholder="Lens" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={3}><div className="mb-3"><Label htmlFor="formrow-country-Input">Vessels and Periphery :</Label><Input type="text" className="form-control" name="ocular_vessels_periphery" placeholder="Vessels and Periphery" onChange={(e) => onValueChange(e)} /></div></Col>
                                    </Row>
                                    <div className="d-flex justify-content-between mt-3">
                                        <Button color="secondary" outline onClick={() => setActiveTab("3")}><i className="mdi mdi-arrow-left me-1" /> Back</Button>
                                        <Button color="danger" onClick={() => setActiveTab("5")}>Next <i className="mdi mdi-arrow-right ms-1" /></Button>
                                    </div>
                                </TabPane>

                                {/* ── Tab 5: Prescription & Assessment ── */}
                                <TabPane tabId="5">
                                    <div style={cardTopStyle}><CardTitle className="mb-4">Prescription</CardTitle></div>
                                    <br />
                                    <div className="table-responsive mb-4">
                                        <Table className="table mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th></th>
                                                    <th>Sphere</th>
                                                    <th>Cyl</th>
                                                    <th>Axis</th>
                                                    <th>Add</th>
                                                    <th>VA</th>
                                                    <th>Prism</th>
                                                    <th>PD</th>
                                                    <th>Seg Height</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row">OD[Right]</th>
                                                    <td><Input type="text" className="form-control" name="Prescription_right_sphere" value={addData.Prescription_right_sphere || ""} onClick={() => handleInputClick("Prescription_right_sphere")} onChange={e => onValueChange(e)} /></td>
                                                    <td><Input type="text" className="form-control" name="Prescription_right_cyl" value={addData.Prescription_right_cyl || ""} onClick={() => handleInputClick1("Prescription_right_cyl")} onChange={e => onValueChange(e)} /></td>
                                                    <td>
                                                        <select name="Prescription_right_axis" className="form-control" value={addData.Prescription_right_axis || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            {renderDropdownOptions()}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select name="Prescription_right_add" className="form-control" value={addData.Prescription_right_add || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            <option>+0.75</option><option>+1.00</option><option>+1.25</option><option>+1.50</option>
                                                            <option>+1.75</option><option>+2.00</option><option>+2.25</option><option>+2.50</option>
                                                            <option>+2.75</option><option>+3.00</option><option>+3.25</option><option>+3.50</option>
                                                        </select>
                                                    </td>
                                                    <td><Input type="text" className="form-control" name="Prescription_right_va" onChange={e => onValueChange(e)} /></td>
                                                    <td><Input type="text" className="form-control" name="Prescription_right_prism" onChange={e => onValueChange(e)} /></td>
                                                    <td><Input type="text" className="form-control" name="Prescription_right_pd" value={addData.Prescription_right_pd || ""} onChange={e => onValueChange(e)} /></td>
                                                    <td>
                                                        <select name="Prescription_right_seg_height" className="form-control" value={addData.Prescription_right_seg_height || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            {renderDropdownOptions1()}
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">OS[Left]</th>
                                                    <td><Input type="text" className="form-control" name="Prescription_left_sphere" value={addData.Prescription_left_sphere || ""} onClick={() => handleInputClick("Prescription_left_sphere")} onChange={e => onValueChange(e)} /></td>
                                                    <td><Input type="text" className="form-control" name="Prescription_left_cyl" value={addData.Prescription_left_cyl || ""} onClick={() => handleInputClick1("Prescription_left_cyl")} onChange={e => onValueChange(e)} /></td>
                                                    <td>
                                                        <select name="Prescription_left_axis" className="form-control" value={addData.Prescription_left_axis || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            {renderDropdownOptions()}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select name="Prescription_left_add" className="form-control" value={addData.Prescription_left_add || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            <option>+0.75</option><option>+1.00</option><option>+1.25</option><option>+1.50</option>
                                                            <option>+1.75</option><option>+2.00</option><option>+2.25</option><option>+2.50</option>
                                                            <option>+2.75</option><option>+3.00</option><option>+3.25</option><option>+3.50</option>
                                                        </select>
                                                    </td>
                                                    <td><Input type="text" className="form-control" name="Prescription_left_va" onChange={e => onValueChange(e)} /></td>
                                                    <td><Input type="text" className="form-control" name="Prescription_left_prism" onChange={e => onValueChange(e)} /></td>
                                                    <td><Input type="text" className="form-control" name="Prescription_left_pd" value={addData.Prescription_left_pd || ""} onChange={e => onValueChange(e)} /></td>
                                                    <td>
                                                        <select name="Prescription_left_seg_height" className="form-control" value={addData.Prescription_left_seg_height || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            {renderDropdownOptions1()}
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                    {(addData.Prescription_right_pd || addData.Prescription_left_pd) && (
                                        <div className="d-flex align-items-center gap-3 mb-3 px-1">
                                            <span style={{ fontSize: 13, color: "#555" }}>
                                                OD[Right] PD : <strong>{addData.Prescription_right_pd || "—"}</strong>
                                            </span>
                                            <span style={{ fontSize: 13, color: "#555" }}>+</span>
                                            <span style={{ fontSize: 13, color: "#555" }}>
                                                OS[Left] PD : <strong>{addData.Prescription_left_pd || "—"}</strong>
                                            </span>
                                            <span style={{ fontSize: 13, color: "#555" }}>=</span>
                                            <span style={{ fontSize: 14, fontWeight: 700, color: "#DC4C64" }}>
                                                Total PD: {
                                                    (parseFloat(addData.Prescription_right_pd) || 0) +
                                                        (parseFloat(addData.Prescription_left_pd) || 0)
                                                        ? ((parseFloat(addData.Prescription_right_pd) || 0) + (parseFloat(addData.Prescription_left_pd) || 0)).toFixed(2)
                                                        : "—"
                                                }
                                            </span>
                                        </div>
                                    )}
                                    <div style={cardTopStyle}><CardTitle className="mb-4">Assessment</CardTitle></div>
                                    <br />
                                    <Row>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Myopia :</Label>
                                                <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                                    {["YES", "NO"].map((option) => {
                                                        const isActive = Patientcare.assesment_myopia === option;
                                                        return (
                                                            <button
                                                                key={option}
                                                                type="button"
                                                                className="btn btn-sm"
                                                                onClick={() => onValueChange({ target: { name: "assesment_myopia", value: option } })}
                                                                style={{
                                                                    border: "1px solid #DC4C64",
                                                                    backgroundColor: isActive ? "#DC4C64" : "#fff",
                                                                    color: isActive ? "#fff" : "#DC4C64",
                                                                    fontWeight: 600,
                                                                    borderRadius: 20,
                                                                    padding: "6px 14px",
                                                                    minWidth: 58,
                                                                    boxShadow: isActive ? "0 4px 10px rgba(220, 76, 100, 0.18)" : "none",
                                                                }}
                                                            >
                                                                {option}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Hyperopia :</Label>
                                                <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                                    {["YES", "NO"].map((option) => {
                                                        const isActive = Patientcare.assesment_hyperopia === option;
                                                        return (
                                                            <button
                                                                key={option}
                                                                type="button"
                                                                className="btn btn-sm"
                                                                onClick={() => onValueChange({ target: { name: "assesment_hyperopia", value: option } })}
                                                                style={{
                                                                    border: "1px solid #DC4C64",
                                                                    backgroundColor: isActive ? "#DC4C64" : "#fff",
                                                                    color: isActive ? "#fff" : "#DC4C64",
                                                                    fontWeight: 600,
                                                                    borderRadius: 20,
                                                                    padding: "6px 14px",
                                                                    minWidth: 58,
                                                                    boxShadow: isActive ? "0 4px 10px rgba(220, 76, 100, 0.18)" : "none",
                                                                }}
                                                            >
                                                                {option}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Anisometropia :</Label>
                                                <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                                    {["YES", "NO"].map((option) => {
                                                        const isActive = Patientcare.assesment_anisometropia === option;
                                                        return (
                                                            <button
                                                                key={option}
                                                                type="button"
                                                                className="btn btn-sm"
                                                                onClick={() => onValueChange({ target: { name: "assesment_anisometropia", value: option } })}
                                                                style={{
                                                                    border: "1px solid #DC4C64",
                                                                    backgroundColor: isActive ? "#DC4C64" : "#fff",
                                                                    color: isActive ? "#fff" : "#DC4C64",
                                                                    fontWeight: 600,
                                                                    borderRadius: 20,
                                                                    padding: "6px 14px",
                                                                    minWidth: 58,
                                                                    boxShadow: isActive ? "0 4px 10px rgba(220, 76, 100, 0.18)" : "none",
                                                                }}
                                                            >
                                                                {option}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className="mb-3">
                                                <Label htmlFor="formrow-country-Input">Astigmatism :</Label>
                                                <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                                    {["YES", "NO"].map((option) => {
                                                        const isActive = Patientcare.assesment_astigmatism === option;
                                                        return (
                                                            <button
                                                                key={option}
                                                                type="button"
                                                                className="btn btn-sm"
                                                                onClick={() => onValueChange({ target: { name: "assesment_astigmatism", value: option } })}
                                                                style={{
                                                                    border: "1px solid #DC4C64",
                                                                    backgroundColor: isActive ? "#DC4C64" : "#fff",
                                                                    color: isActive ? "#fff" : "#DC4C64",
                                                                    fontWeight: 600,
                                                                    borderRadius: 20,
                                                                    padding: "6px 14px",
                                                                    minWidth: 58,
                                                                    boxShadow: isActive ? "0 4px 10px rgba(220, 76, 100, 0.18)" : "none",
                                                                }}
                                                            >
                                                                {option}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        </Col>
                                        {/* <Col md={2}><div className="mb-3"><Label htmlFor="formrow-country-Input">Antistigmatism :</Label><Input type="text" className="form-control" name="assesment_antistigmatism" placeholder="Antistigmatism" onChange={(e) => onValueChange(e)} /></div></Col>
                                        <Col md={2}><div className="mb-3"><Label htmlFor="formrow-country-Input">Pathology :</Label><Input type="text" className="form-control" name="assesment_pathology" placeholder="Pathology" onChange={(e) => onValueChange(e)} /></div></Col> */}
                                    </Row>
                                    <div className="d-flex justify-content-between mt-3">
                                        <Button color="secondary" outline onClick={() => setActiveTab("4")}><i className="mdi mdi-arrow-left me-1" /> Back</Button>
                                        <Button color="danger" onClick={() => setActiveTab("6")}>Next <i className="mdi mdi-arrow-right ms-1" /></Button>
                                    </div>
                                </TabPane>
                                {/* ── Tab 6: Optical & Frame ── */}
                                <TabPane tabId="6">
                                    <Row>
                                        {/* ── Frame Details FIRST ── */}
                                        <Col md={4}>
                                            <div style={cardTopStyle}><CardTitle className="mb-4">Frame Details</CardTitle></div>
                                            <br />
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3" ref={frameSearchRef} style={{ position: "relative" }}>
                                                        <Label style={{ fontWeight: 600, fontSize: 13 }}>
                                                            <i className="mdi mdi-barcode-scan me-1" style={{ color: "#DC4C64" }} />
                                                            Search Frame by Code
                                                            <span style={{ fontSize: 11, color: "#999", fontWeight: 400, marginLeft: 6 }}>(from frame stock by practice)</span>
                                                        </Label>
                                                        <div style={{ position: "relative" }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder={clinicIdFromToken || selectedClinic ? "Type frame code or frame name" : "Select Practice first"}
                                                                value={frameCodeQuery}
                                                                onChange={(e) => handleFrameCodeSearch(e.target.value)}
                                                                disabled={!clinicIdFromToken && !selectedClinic}
                                                                style={{ paddingRight: 36, fontSize: 13, borderColor: "#DC4C64", borderRadius: 6 }}
                                                            />
                                                            {frameSearchLoading && (
                                                                <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 14, color: "#DC4C64" }}>
                                                                    <i className="mdi mdi-loading mdi-spin" />
                                                                </span>
                                                            )}
                                                            {frameCodeQuery && (
                                                                <span
                                                                    onClick={() => {
                                                                        setFrameCodeQuery("");
                                                                        setFrameSearchResults([]);
                                                                        setFrameSearchOpen(false);
                                                                    }}
                                                                    style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 18, color: "#bbb", cursor: "pointer", lineHeight: 1 }}
                                                                >
                                                                    ×
                                                                </span>
                                                            )}
                                                        </div>
                                                        {!clinicIdFromToken && !selectedClinic && (
                                                            <div style={{ fontSize: 11, color: "#DC4C64", marginTop: 6 }}>
                                                                Please select Practice in Patient Care before searching frame stock.
                                                            </div>
                                                        )}

                                                        {frameSearchOpen && (
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: "100%",
                                                                    left: 0,
                                                                    right: 0,
                                                                    background: "#fff",
                                                                    border: "1px solid #eee",
                                                                    borderRadius: 8,
                                                                    boxShadow: "0 8px 24px rgba(0,0,0,.08)",
                                                                    zIndex: 50,
                                                                    marginTop: 6,
                                                                    maxHeight: 260,
                                                                    overflowY: "auto",
                                                                }}
                                                            >
                                                                {frameSearchResults.length > 0 ? (
                                                                    frameSearchResults.map((stockItem) => (
                                                                        <div
                                                                            key={stockItem._id}
                                                                            onClick={() => handleFrameCodeSelect(stockItem)}
                                                                            style={{
                                                                                padding: "10px 12px",
                                                                                borderBottom: "1px solid #f5f5f5",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            <div style={{ fontWeight: 700, fontSize: 13, color: "#333" }}>
                                                                                {stockItem.fcode || "No Code"}
                                                                            </div>
                                                                            <div style={{ fontSize: 12, color: "#666", marginTop: 2 }}>
                                                                                {stockItem.fname_id?.frame_title || stockItem.fname_id?.frame_name || stockItem.fname}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <div style={{ padding: "10px 12px", fontSize: 12, color: "#999" }}>
                                                                        No frame found for this practice
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-size-Input">Frame Brand :</Label>
                                                        <Input type="text" className="form-control" name="frame_brand" value={addData.frame_brand || ""} onChange={e => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-country-Input">Frame Color :</Label>
                                                        <Input type="text" className="form-control" name="frame_color" value={addData.frame_color || ""} placeholder="Frame Color" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-country-Input">Frame Size :</Label>
                                                        <Input type="text" className="form-control" name="frame_size" value={addData.frame_size || ""} placeholder="Frame Size" onChange={(e) => onValueChange(e)} />
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-size-Input"> Material :</Label>
                                                        <select name="frame_material" className="form-control" value={addData.frame_material || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            <option>Acetate</option>
                                                            <option>Titanium</option>
                                                            <option>Nylon</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-size-Input">Type :</Label>
                                                        <select name="frame_type" className="form-control" value={addData.frame_type || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            <option>Full Rim</option>
                                                            <option>Semi-rimless</option>
                                                            <option>Rimless</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <Label htmlFor="formrow-size-Input">Shape :</Label>
                                                        <select name="frame_shape" className="form-control" value={addData.frame_shape || ""} onChange={e => onValueChange(e)}>
                                                            <option value="">Select</option>
                                                            <option>Rectangle</option>
                                                            <option>cat-eye</option>
                                                            <option>Round</option>
                                                            <option>Oval</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>

                                        {/* ── Optical Details SECOND — locked until frame filled ── */}
                                        {(() => {
                                            const frameDetailsFilled = !!(
                                                addData.frame_brand || addData.frame_color || addData.frame_size ||
                                                (addData.frame_material && addData.frame_material !== "Select") ||
                                                (addData.frame_type && addData.frame_type !== "Select") ||
                                                (addData.frame_shape && addData.frame_shape !== "Select")
                                            );
                                            return (
                                                <Col md={8}>
                                                    <div style={cardTopStyle}><CardTitle className="mb-4">Optical Details</CardTitle></div>
                                                    <br />
                                                    {/* ── Lens Code Search — OUTSIDE fieldset so it's always active ── */}
                                                    <div className="mb-3" ref={lensSearchRef} style={{ position: "relative" }}>
                                                        <Label style={{ fontWeight: 600, fontSize: 13 }}>
                                                            <i className="mdi mdi-barcode-scan me-1" style={{ color: "#DC4C64" }} />
                                                            Search Lens by Code
                                                            <span style={{ fontSize: 11, color: "#999", fontWeight: 400, marginLeft: 6 }}>(auto-fills OD &amp; OS)</span>
                                                        </Label>
                                                        <div style={{ position: "relative" }}>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Type lens code e.g. CR39-SIN-STK-HC…"
                                                                value={lensCodeQuery}
                                                                onChange={e => handleLensCodeSearch(e.target.value)}
                                                                style={{ paddingRight: 36, fontSize: 13, borderColor: "#DC4C64", borderRadius: 6 }}
                                                            />
                                                            {lensSearchLoading && (
                                                                <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 14, color: "#DC4C64" }}>
                                                                    <i className="mdi mdi-loading mdi-spin" />
                                                                </span>
                                                            )}
                                                            {lensCodeQuery && !lensSearchLoading && (
                                                                <span onClick={() => { setLensCodeQuery(""); setLensSearchResults([]); setLensSearchOpen(false); }}
                                                                    style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 18, color: "#bbb", cursor: "pointer", lineHeight: 1 }}>×</span>
                                                            )}
                                                        </div>
                                                        {lensSearchOpen && lensSearchResults.length > 0 && (
                                                            <div style={{ position: "absolute", zIndex: 1050, top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid #e0e0e0", borderRadius: 6, boxShadow: "0 4px 16px rgba(0,0,0,0.12)", maxHeight: 240, overflowY: "auto" }}>
                                                                {lensSearchResults.map((item, idx) => {
                                                                    const doc = item.lname_id;
                                                                    return (
                                                                        <div key={idx} onClick={() => handleLensCodeSelect(item)}
                                                                            style={{ padding: "9px 14px", cursor: "pointer", borderBottom: "1px solid #f5f5f5", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12 }}
                                                                            onMouseEnter={e => e.currentTarget.style.background = "#fff5f5"}
                                                                            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                                                                            <div>
                                                                                <div style={{ fontWeight: 700, color: "#DC4C64", fontSize: 13 }}>{item.lcode}</div>
                                                                                <div style={{ color: "#666", marginTop: 2 }}>
                                                                                    {doc?.lens_vision_name || ""}{doc?.sub_type ? ` • ${doc.sub_type}` : ""}{doc?.lens_type ? ` • ${doc.lens_type}` : ""}{doc?.lens_material ? ` • ${doc.lens_material}` : ""}
                                                                                </div>
                                                                            </div>
                                                                            <div style={{ textAlign: "right", flexShrink: 0, marginLeft: 12 }}>
                                                                                <div style={{ color: "#888", fontSize: 11 }}>Qty: <strong>{item.lqty}</strong></div>
                                                                                {doc?.price && <div style={{ color: "#DC4C64", fontWeight: 700 }}>R {doc.price}</div>}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                        {lensSearchOpen && !lensSearchLoading && lensSearchResults.length === 0 && lensCodeQuery && (
                                                            <div style={{ position: "absolute", zIndex: 1050, top: "100%", left: 0, right: 0, background: "#fff", border: "1px solid #e0e0e0", borderRadius: 6, padding: "12px 14px", fontSize: 12, color: "#888", boxShadow: "0 4px 16px rgba(0,0,0,0.08)" }}>
                                                                No lens found for "<strong>{lensCodeQuery}</strong>"
                                                            </div>
                                                        )}
                                                    </div>

                                                    {!frameDetailsFilled && (
                                                        <div style={{ background: "#fff3cd", border: "1px solid #ffc107", borderRadius: 6, padding: "10px 14px", marginBottom: 14, display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#856404" }}>
                                                            <i className="mdi mdi-lock-outline" style={{ fontSize: 16 }} />
                                                            Please fill in <strong style={{ marginLeft: 3 }}>Frame Details</strong> first before entering Optical Details.
                                                        </div>
                                                    )}
                                                    <fieldset disabled={!frameDetailsFilled} style={{ border: "none", padding: 0, margin: 0, opacity: frameDetailsFilled ? 1 : 0.45 }}>
                                                        <Row>

                                                            <Col md={12}>
                                                                <div className="mb-3">
                                                                    <Label htmlFor="formrow-country-Input">Lens Category :</Label>
                                                                    <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                                                        {["CR-39(Plastic)", "Polycarbonate", "Glass", "Uncut"].map((materialOption) => {
                                                                            const isMaterialActive = (val) => val && val.toLowerCase() === materialOption.toLowerCase();
                                                                            const isActive = isMaterialActive(Patientcare.material) || isMaterialActive(addData.material);
                                                                            return (
                                                                                <button
                                                                                    key={materialOption}
                                                                                    type="button"
                                                                                    className="btn btn-sm"
                                                                                    onClick={() => { onValueChange({ target: { name: "material", value: materialOption } }); setShowMaterialWarning(false); }}
                                                                                    style={{
                                                                                        border: "1px solid #DC4C64",
                                                                                        backgroundColor: isActive ? "#DC4C64" : "#fff",
                                                                                        color: isActive ? "#fff" : "#DC4C64",
                                                                                        fontWeight: 600,
                                                                                        borderRadius: 20,
                                                                                        padding: "6px 14px",
                                                                                        boxShadow: isActive ? "0 4px 10px rgba(220, 76, 100, 0.18)" : "none",
                                                                                        transition: "all 0.2s ease",
                                                                                    }}
                                                                                >
                                                                                    {materialOption}
                                                                                </button>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            {/* ── Per-Eye Lens Selection ── */}
                                                            <Col md={12}>
                                                                <Row>
                                                                    {/* ── OD (Right Eye) ── */}
                                                                    <Col md={6}>

                                                                        <div style={{ position: "relative" }}>
                                                                            {!Patientcare.material && (
                                                                                <div
                                                                                    style={{ position: "absolute", inset: 0, zIndex: 2, borderRadius: 8, cursor: "not-allowed", background: "rgba(255,255,255,0.45)" }}
                                                                                    onClick={() => setShowMaterialWarning(true)}
                                                                                />
                                                                            )}
                                                                            <div style={{ background: "#fff8f8", border: `1px solid ${!Patientcare.material ? "#e0e0e0" : "#f5c6c6"}`, borderRadius: 8, padding: "14px 16px", marginBottom: 4, opacity: !Patientcare.material ? 2.5 : 1 }}>
                                                                                <div style={{ fontWeight: 700, color: "#C62828", marginBottom: 10, fontSize: 13 }}>
                                                                                    <i className="mdi mdi-eye-outline me-1" /> OD [Right Eye] Lens Selection
                                                                                </div>
                                                                                <Row>
                                                                                    <Col md={6}>
                                                                                        <div className="mb-2">
                                                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>1. Vision Category :</Label>
                                                                                            <select className="form-control form-control-sm" value={selectedVision || ""} onChange={handleVisionChange}>
                                                                                                <option value="">— Select Vision —</option>
                                                                                                {vision.users.map(v => (
                                                                                                    <option key={v._id} value={v._id}>{v.vision}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col md={6}>
                                                                                        <div className="mb-2">
                                                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>2. Sub-Type :</Label>
                                                                                            <select className="form-control form-control-sm" value={selectedSubTypeRecord?.sub_type || ""} onChange={handleSubTypeChange} disabled={!selectedVision}>
                                                                                                <option value="">— Select —</option>
                                                                                                {[...new Set(filteredOptionsvisionType.map(vt => vt.sub_type).filter(Boolean))].map(st => (
                                                                                                    <option key={st} value={st}>{st}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col md={8}>
                                                                                        <div className="mb-2">
                                                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>3. Lens Coating :</Label>
                                                                                            <select className="form-control form-control-sm" value={selectedCoating} onChange={handleCoatingChange} disabled={!selectedSubTypeRecord}>
                                                                                                <option value="">— Select Coating —</option>
                                                                                                {[
                                                                                                    { key: "uc", label: "UC – Uncoated" },
                                                                                                    { key: "hc", label: "HC – Hard Coat" },
                                                                                                    { key: "hmc_blue", label: "HMC Blue – Multi-Coat Blue" },
                                                                                                    { key: "shmc_blue", label: "SHMC Blue – Super Multi-Coat Blue" },
                                                                                                ].map(c => (
                                                                                                    <option key={c.key} value={c.key}>{c.label}</option>
                                                                                                ))}
                                                                                            </select>
                                                                                        </div>
                                                                                    </Col>
                                                                                    <Col md={4}>
                                                                                        <div className="mb-2">
                                                                                            <Label style={{ fontSize: 12, fontWeight: 600 }}>4. Add-on :</Label>
                                                                                            <div className="d-flex align-items-center" style={{ gap: 8, marginTop: 4 }}>
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id="photochromic_chk_od"
                                                                                                    onClick={handlePhotochromicChange}
                                                                                                    checked={isPhotochromic}
                                                                                                    onChange={() => { }}
                                                                                                    disabled={!selectedSubTypeRecord}
                                                                                                    style={{ width: 16, height: 16, cursor: "pointer" }}
                                                                                                />
                                                                                                <label htmlFor="photochromic_chk_od" style={{ margin: 0, fontSize: 13, cursor: "pointer" }}>Photo</label>
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        </div>
                                                                        {showMaterialWarning && !Patientcare.material && (
                                                                            <div style={{ color: "#DC4C64", fontSize: 12, fontWeight: 600, marginBottom: 8, display: "flex", alignItems: "center", gap: 4 }}>
                                                                                <i className="mdi mdi-alert-circle-outline" />
                                                                                Please select Lens Material first.
                                                                            </div>
                                                                        )}
                                                                    </Col>

                                                                    {/* ── OS (Left Eye) ── */}
                                                                    <Col md={6}>
                                                                        <div style={{ background: "#f8f8ff", border: "1px solid #c6c6f5", borderRadius: 8, padding: "14px 16px", marginBottom: 12 }}>
                                                                            <div style={{ fontWeight: 700, color: "#2828C6", marginBottom: 10, fontSize: 13 }}>
                                                                                <i className="mdi mdi-eye-outline me-1" /> OS [Left Eye] Lens Selection
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        id="enable_os_lens_edit"
                                                                                        ref={osLensEditCheckboxRef}
                                                                                        defaultChecked={isOSLensEditable}
                                                                                        onClick={handleOSLensEditToggle}
                                                                                        style={{ width: 16, height: 16, cursor: "pointer" }}
                                                                                    />
                                                                                    <label htmlFor="enable_os_lens_edit" style={{ margin: 0, fontSize: 13, cursor: "pointer", fontWeight: 500 }}>
                                                                                        Allow changes in OS lens selection
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                            <Row>
                                                                                <Col md={6}>
                                                                                    <div className="mb-2">
                                                                                        <Label style={{ fontSize: 12, fontWeight: 600 }}>1. Vision Category :</Label>
                                                                                        <select className="form-control form-control-sm" value={selectedVisionOS || ""} onChange={handleVisionChangeOS} disabled={!isOSLensEditable}>
                                                                                            <option value="">— Select Vision —</option>
                                                                                            {vision.users.map(v => (
                                                                                                <option key={v._id} value={v._id}>{v.vision}</option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md={6}>
                                                                                    <div className="mb-2">
                                                                                        <Label style={{ fontSize: 12, fontWeight: 600 }}>2. Sub-Type :</Label>
                                                                                        <select className="form-control form-control-sm" value={selectedSubTypeRecordOS?.sub_type || ""} onChange={handleSubTypeChangeOS} disabled={!isOSLensEditable || !selectedVisionOS}>
                                                                                            <option value="">— Select —</option>
                                                                                            {[...new Set(filteredSubTypesOS.map(vt => vt.sub_type).filter(Boolean))].map(st => (
                                                                                                <option key={st} value={st}>{st}</option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md={8}>
                                                                                    <div className="mb-2">
                                                                                        <Label style={{ fontSize: 12, fontWeight: 600 }}>3. Lens Coating :</Label>
                                                                                        <select className="form-control form-control-sm" value={selectedCoatingOS} onChange={handleCoatingChangeOS} disabled={!isOSLensEditable || !selectedSubTypeRecordOS}>
                                                                                            <option value="">— Select Coating —</option>
                                                                                            {[
                                                                                                { key: "uc", label: "UC – Uncoated" },
                                                                                                { key: "hc", label: "HC – Hard Coat" },
                                                                                                { key: "hmc_blue", label: "HMC Blue – Multi-Coat Blue" },
                                                                                                { key: "shmc_blue", label: "SHMC Blue – Super Multi-Coat Blue" },
                                                                                            ].map(c => (
                                                                                                <option key={c.key} value={c.key}>{c.label}</option>
                                                                                            ))}
                                                                                        </select>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md={4}>
                                                                                    <div className="mb-2">
                                                                                        <Label style={{ fontSize: 12, fontWeight: 600 }}>4. Add-on :</Label>
                                                                                        <div className="d-flex align-items-center" style={{ gap: 8, marginTop: 4 }}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                id="photochromic_chk_os"
                                                                                                ref={osPhotochromicCheckboxRef}
                                                                                                onClick={handlePhotochromicChangeOS}
                                                                                                defaultChecked={isPhotochromicOS}
                                                                                                onChange={() => { }}
                                                                                                disabled={!isOSLensEditable || !selectedSubTypeRecordOS}
                                                                                                style={{ width: 16, height: 16, cursor: "pointer" }}
                                                                                            />
                                                                                            <label htmlFor="photochromic_chk_os" style={{ margin: 0, fontSize: 13, cursor: "pointer" }}>Photo</label>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </fieldset>
                                                </Col>
                                            );
                                        })()}
                                    </Row>

                                    <div className="d-flex justify-content-between mt-3">
                                        <Button color="secondary" outline onClick={() => setActiveTab("5")}><i className="mdi mdi-arrow-left me-1" /> Back</Button>
                                        <button
                                            className="btn btn-danger px-5"
                                            onClick={addpatientcareDetails}
                                            disabled={loader}
                                        >
                                            {loader ? (
                                                <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Saving...</>
                                            ) : (
                                                <><i className="mdi mdi-content-save me-1" />Save Patient Care</>
                                            )}
                                        </button>
                                    </div>
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>

                    {/* ── Modals ── */}
                    <Modal
                        isOpen={modalOpen}
                        toggle={() => setModalOpen(!modalOpen)}
                    >
                        <ModalHeader
                            toggle={() =>
                                setModalOpen(!modalOpen)
                            }
                        >
                            SPH(Right)
                        </ModalHeader>
                        <ModalBody>
                            <Row>
                                <Col md={12}>
                                    <Row>
                                        <Col md={6}>
                                            <h5>(-) Minus values</h5>
                                            {[
                                                "-0.25",
                                                "-0.50",
                                                "-0.75",
                                                "-1.00",
                                                "-1.50",
                                                "-1.75",
                                                "-2.00",
                                                "-2.00",
                                                "-2.25",
                                                "-2.50",
                                                "-2.75",
                                                "-3.00",
                                                "-3.25",
                                                "-3.50",
                                                "-3.75",
                                                "-4.00",
                                                "-4.25",
                                                "-4.50",
                                                "-4.75",
                                                "-5.00",
                                                "-5.25",
                                            ].map((value, index) => (
                                                <Button
                                                    key={index}
                                                    outline="secondary"
                                                    style={{
                                                        margin: "5px",
                                                        width:
                                                            "calc(30% - 10px)",
                                                    }}
                                                    onClick={() =>
                                                        handleSelectValue(value)
                                                    }
                                                >
                                                    {value}
                                                </Button>
                                            ))}
                                        </Col>
                                        <Col md={6}>
                                            <h5>(+) Plus values</h5>
                                            {[
                                                "+0.25",
                                                "+0.50",
                                                "+0.75",
                                                "+1.00",
                                                "+1.50",
                                                "+1.75",
                                                "+2.00",
                                                "+2.00",
                                                "+2.25",
                                                "+2.50",
                                                "+2.75",
                                                "+3.00",
                                                "+3.25",
                                                "+3.50",
                                                "+3.75",
                                                "+4.00",
                                                "+4.25",
                                                "+4.50",
                                                "+4.75",
                                                "+5.00",
                                                "+5.25",
                                            ].map((value, index) => (
                                                <Button
                                                    key={index}
                                                    outline="secondary"
                                                    style={{
                                                        margin: "5px",
                                                        width:
                                                            "calc(30% - 10px)",
                                                    }}
                                                    onClick={() =>
                                                        handleSelectValue(value)
                                                    }
                                                >
                                                    {value}
                                                </Button>
                                            ))}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </ModalBody>
                        <ModalFooter>
                            {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                        </ModalFooter>
                    </Modal>
                    <Modal
                        isOpen={modalOpen1}
                        toggle={() =>
                            setModalOpen1(!modalOpen1)
                        }
                    >
                        <ModalHeader
                            toggle={() =>
                                setModalOpen1(!modalOpen1)
                            }
                        >
                            CYL(Right)
                        </ModalHeader>
                        <ModalBody>
                            <h5>(-) Minus values</h5>
                            {[
                                "-0.25",
                                "-0.50",
                                "-0.75",
                                "-1.00",
                                "-1.50",
                                "-1.75",
                                "-2.00",
                                "-2.00",
                                "-2.25",
                                "-2.50",
                                "-2.75",
                                "-3.00",
                                "-3.25",
                                "-3.50",
                                "-3.75",
                                "-4.00",
                                "-4.25",
                                "-4.50",
                                "-4.75",
                                "-5.00",
                                "-5.25",
                                "-6.00",
                                "-6.25",
                                "-6.50",
                            ].map((value, index) => (
                                <Button
                                    key={index}
                                    outline="secondary"
                                    style={{
                                        margin: "5px",
                                        width: "calc(15% - 10px)",
                                    }}
                                    onClick={() =>
                                        handleSelectValue1(value)
                                    }
                                >
                                    {value}
                                </Button>
                            ))}
                        </ModalBody>
                        <ModalFooter>
                            {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                        </ModalFooter>
                    </Modal>
                    <Modal
                        isOpen={modalOpen2}
                        toggle={() =>
                            setModalOpen2(!modalOpen2)
                        }
                    >
                        <ModalHeader
                            toggle={() =>
                                setModalOpen2(!modalOpen2)
                            }
                        >
                            PD(Pupillary Distance)
                        </ModalHeader>
                        <ModalBody>
                            {/* <h5>(-) Minus values</h5> */}
                            {[
                                "54.00",
                                "54.50",
                                "55.00",
                                "55.50",
                                "56.00",
                                "56.50",
                                "57.00",
                                "57.50",
                                "58.00",
                                "58.50",
                                "59.00",
                                "59.50",
                                "60.00",
                                "60.50",
                                "61.00",
                                "61.50",
                                "62.00",
                                "62.50",
                                "63.00",
                                "63.50",
                                "64.00",
                                "64.50",
                                "65.00",
                                "65.50",
                                "66.00",
                                "66.50",
                                "67.00",
                                "67.50",
                                "68.00",
                                "68.50",
                                "69.00",
                                "69.50",
                                "70.00",
                                "70.50",
                                "71.00",
                                "71.50",
                                "72.00",
                                "72.50",
                                "73.00",
                                "73.50",
                                "74.00",
                                "74.50",
                                "75.00",
                                "75.50",
                                "76.00",
                                "76.50",
                                "77.00",
                                "77.50",
                                "78.00",
                                "78.50",
                            ].map((value, index) => (
                                <Button
                                    key={index}
                                    outline="secondary"
                                    style={{
                                        margin: "5px",
                                        width: "calc(15% - 10px)",
                                    }}
                                    onClick={() =>
                                        handleSelectValue2(value)
                                    }
                                >
                                    {value}
                                </Button>
                            ))}
                        </ModalBody>
                        <ModalFooter>
                            {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                        </ModalFooter>
                    </Modal>
                    <Modal
                        isOpen={modalOpen3}
                        toggle={() =>
                            setModalOpen3(!modalOpen3)
                        }
                    >
                        <ModalHeader
                            toggle={() =>
                                setModalOpen3(!modalOpen3)
                            }
                        >
                            PD(Left)
                        </ModalHeader>
                        <ModalBody>
                            {/* <h5>(-) Minus values</h5> */}
                            {[
                                "25.00",
                                "25.50",
                                "26.00",
                                "26.50",
                                "27.00",
                                "27.50",
                                "28.00",
                                "28.50",
                                "29.00",
                                "29.50",
                                "30.00",
                                "30.50",
                                "31.00",
                                "31.50",
                                "32.00",
                                "32.50",
                                "33.00",
                                "33.50",
                                "34.00",
                                "34.50",
                            ].map((value, index) => (
                                <Button
                                    key={index}
                                    outline="secondary"
                                    style={{
                                        margin: "5px",
                                        width: "calc(15% - 10px)",
                                    }}
                                    onClick={() =>
                                        handleSelectValue3(value)
                                    }
                                >
                                    {value}
                                </Button>
                            ))}
                        </ModalBody>
                        <ModalFooter>
                            {/* <Button color="light" onClick={() => setModalOpen(false)}>Cancel</Button> */}
                        </ModalFooter>
                    </Modal>
                    {/* ── Visual Acuity Value Picker Modal ── */}
                    <Modal isOpen={vaModal.open} toggle={() => setVaModal({ open: false, field: null })} centered size="sm">
                        <ModalHeader toggle={() => setVaModal({ open: false, field: null })}>
                            Select Visual Acuity
                        </ModalHeader>
                        <ModalBody>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
                                {VA_VALUES.map(val => (
                                    <Button
                                        key={val}
                                        outline
                                        color="danger"
                                        style={{ width: "calc(33% - 8px)", fontSize: 14, fontWeight: 600 }}
                                        onClick={() => handleVASelect(val)}
                                    >
                                        {val}
                                    </Button>
                                ))}
                            </div>
                        </ModalBody>
                    </Modal>

                    <Modal isOpen={frameCaptureModal} toggle={() => setFrameCaptureModal(!frameCaptureModal)} size="lg">
                        <ModalHeader toggle={() => setFrameCaptureModal(false)}>
                            Capture Frame Image
                        </ModalHeader>
                        <ModalBody>
                            <div className="d-flex flex-column align-items-center">
                                <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/jpeg"
                                    width={500}
                                    height={350}
                                    videoConstraints={{ facingMode: "user" }}
                                />
                                <Button color="primary" className="mt-3" onClick={captureImage}>
                                    Capture
                                </Button>
                            </div>
                            {webcamImage && (
                                <div className="text-center mt-3">
                                    <p>Captured Image:</p>
                                    <img src={webcamImage} alt="Captured" className="img-fluid" />
                                </div>
                            )}
                        </ModalBody>
                    </Modal>

                </Container>
            </div>
        </React.Fragment >
    )
}

export default Addpatientcare
